import Select from "react-select";
import { COUNTRY_OPTIONS } from "../constants/countryOptions";
import { customSelectStyles } from "../CustomStyles/CustomSelect";

export default function AdditionalInfoSection({ product, setProduct }) {
  const selectedCountry = String(product.countryOfOrigin || "Canada").trim();
  const selectedOption =
    COUNTRY_OPTIONS.find((opt) => opt.value === selectedCountry) || {
      value: selectedCountry || "Canada",
      label: selectedCountry || "Canada",
    };
  const isBaseProduct =
    !String(product.baseProductSku || "").trim() && !product.isVariant;
  const hsCodeOverrideEnabled = product.hsCodeOverride !== false;
  const requireHsCode = isBaseProduct && hsCodeOverrideEnabled;

  return (
    <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-3 sm:p-6 md:p-8 min-w-0 w-full max-w-full overflow-hidden">
      <h2 className="text-lg sm:text-xl md:text-2xl font-semibold mb-4 sm:mb-6">
        ADDITIONAL INFO
      </h2>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Country of Origin
          </label>
          <Select
            options={COUNTRY_OPTIONS}
            value={selectedOption}
            onChange={(option) =>
              setProduct({
                ...product,
                countryOfOrigin: option?.value || "Canada",
              })
            }
            placeholder="Select country"
            isSearchable
            maxMenuHeight={200}
            classNamePrefix="react-select"
            styles={customSelectStyles}
          />
        </div>

        <div>
          <div className="flex items-center justify-between mb-2">
            <label className="flex items-center gap-2 text-sm font-medium text-gray-700">
              Harmonized Tariff (HS Code)
              {requireHsCode && <span className="text-red-500">*</span>}
            </label>
            {isBaseProduct && (
              <label className="flex items-center gap-2 text-xs">
                <input
                  type="checkbox"
                  checked={hsCodeOverrideEnabled}
                  onChange={(e) =>
                    setProduct({
                      ...product,
                      hsCodeOverride: e.target.checked,
                    })
                  }
                />
                <span>Override</span>
              </label>
            )}
          </div>
          <input
            type="text"
            // placeholder="e.g., 0904.22.00"
            placeholder="e.g.,0910.99.6000"
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-black focus:border-transparent"
            value={product.harmonizedTariff || ""}
            onChange={(e) =>
              setProduct({
                ...product,
                harmonizedTariff: e.target.value,
              })
            }
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Expiry Days
          </label>
          <input
            type="number"
            min="0"
            placeholder="1095"
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-black focus:border-transparent"
            value={product.expiryDays}
            onChange={(e) =>
              setProduct({ ...product, expiryDays: e.target.value })
            }
          />
          <p className="text-xs text-gray-500 mt-1">
            Default: 1095 days (3 years)
          </p>
        </div>
      </div>
    </div>
  );
}
